// extracted by mini-css-extract-plugin
export default {"wrapper":"TitleDuoTone_wrapper__z8Phr","title":"TitleDuoTone_title__fw+Zz","primaryColor":"TitleDuoTone_primaryColor__SkYnj"};